import store from '../../../core/store';
import { backendURL } from '../../../core/utils';
import { downloadFile } from './downloader';

export const showLightbox = (images = [], active) => {
  const activeImage = images.find(
    (image) => image.id == active || image.attachment_version_id == active
  );
  const normalizedImages = images.map((image) => ({
    ...image,
    attachment_id: image.attachment_id || image.id,
    id: image.attachment_version_id || image.id,
  }));

  return store.dispatch({
    type: 'general.lightbox/SHOW_LIGHTBOX',
    images: normalizedImages,
    active: activeImage?.attachment_version_id || active,
  });
};

export const hideLightbox = () => {
  return store.dispatch({
    type: 'general.lightbox/HIDE_LIGHTBOX',
  });
};

export const readAttachmentVersionAnnotations = (attachment_version_id) => {
  return store.dispatch({
    action: 'general.lightbox/READ_ATTACHMENT_ANNOTATION',
    method: 'GET',
    endpoint: '/attachment_versions/' + attachment_version_id + '/annotations',
    has404: true,
  });
};

export const updateAttachmentVersionAnnotation = (attachment_version_id, objects) => {
  return store.dispatch({
    action: 'general.lightbox/UPDATE_ATTACHMENT_ANNOTATION',
    method: 'PUT',
    endpoint: '/attachment_versions/' + attachment_version_id + '/annotations',
    data: { data: objects },
  });
};

// export const exportAttachmentAnnotations = (attachment_id, formData) => {
//   return store.dispatch({
//     action: 'table.working_set_plans/EXPORT_WORKING_SET_PLAN',
//     method: 'POST',
//     endpoint: '/attachments/' + attachment_id + '/export',
//     data: formData,
//   });
// };

export const exportAttachmentAnnotations = (attachment_id, formData) => {
  return downloadFile(
    backendURL + '/attachments/' + attachment_id + '/export',
    formData,
    'POST'
  );
};

export const setPdfScale = (pdfScale) => {
  return store.dispatch({
    type: 'general.lightbox/SET_PDF_SCALE',
    pdfScale,
  });
};
